import { Observable, of } from 'rxjs';
import { mockPrintableDocuments, PrintableDocument } from '@sc/portal.fe.lib.app-components';

export class PolicyDocumentsServiceStub {
  getDocuments(policyNumber: string): Observable<PrintableDocument[]> {
    return of(mockPrintableDocuments(3))
  }
}
